// Bridges a private-challenge exam with its invite code, so finishing the exam
// can redirect straight to the challenge leaderboard instead of the normal results page.
const PREFIX = "enarm_challenge_invite";

function buildKey(examId) {
  return `${PREFIX}_${examId}`;
}

export function linkChallengeInviteCode(examId, inviteCode) {
  if (!examId || !inviteCode) return;

  try {
    localStorage.setItem(buildKey(examId), String(inviteCode));
  } catch (error) {
    console.warn("No se pudo guardar la referencia del reto.", error);
  }
}

export function getChallengeInviteCode(examId) {
  if (!examId) return null;

  try {
    return localStorage.getItem(buildKey(examId));
  } catch (error) {
    console.warn("No se pudo leer la referencia del reto.", error);
    return null;
  }
}

export function consumeChallengeInviteCode(examId) {
  if (!examId) return null;

  try {
    const key = buildKey(examId);
    const inviteCode = localStorage.getItem(key);

    if (inviteCode) {
      localStorage.removeItem(key);
    }

    return inviteCode;
  } catch (error) {
    console.warn("No se pudo leer la referencia del reto.", error);
    return null;
  }
}
